export const SUPPORTS_ARRAY_PROTOTYPE_POP = "pop" in Array.prototype;
